<template>
  <div v-if="isValidData()">
    <div class="created_at_date">{{ params.value.date }}</div>
    <div class="created_at_time">{{ params.value.time }}</div>
  </div>
  <div v-else>{{ params.value }}</div>
</template>

<script>
export default {
  methods: {
    isValidData () {
      return typeof this.params.value === 'object' && this.params.value.date && this.params.value.time
    }
  }
}
</script>

<style lang="scss" scoped>
  .created_at_date {
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
  }

  .created_at_time {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }
</style>
